import {createSlice, isAnyOf} from '@reduxjs/toolkit'
import { ORDER_ITEM } from 'src/app/_interfaces/order.interface'
import {getAllInventoryLocationsAsync, getInventoryLogsAsync} from '../actions/inventoryActions'

type InventoryLocationOption = {
  id: number
  api_id?: string | number
  api_name?: string
  api_code?: string
}

type InitialState = {
    inventoryLogsLoading:boolean
    inventoryLogs:ORDER_ITEM[]|[]
    inventoryPaginationData:{
        // next:string|null
        // previous:string|null
        pageNumber:number
        count:number
    }
    inventoryLocations: InventoryLocationOption[]
}
const initialState:InitialState  = {
  inventoryLogsLoading:false,
  inventoryLogs:[],
  inventoryPaginationData:{
    count:0,
    pageNumber:0
  },
  inventoryLocations: [],
}

const inventorySlice = createSlice({
  name: 'inventorySlice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getInventoryLogsAsync.pending), (state) => {
      console.log('getInventoryLogsAsync is in pending state ')
      state.inventoryLogsLoading = true
    })
    builder.addMatcher(isAnyOf(getInventoryLogsAsync.rejected), (state) => {
      console.log('getInventoryLogsAsync is in rejected state ')
      state.inventoryLogsLoading = false
    })
    builder.addMatcher(isAnyOf(getInventoryLogsAsync.fulfilled), (state, action) => {
        console.log('getInventoryLogsAsync is in fulfilled state ', action.payload )
        state.inventoryLogsLoading = false
        state.inventoryLogs = action.payload.data.inventory_logs
        state.inventoryPaginationData.count = action.payload?.data.total_items
        state.inventoryPaginationData.pageNumber = action.payload?.data.current_page


    })
    builder.addMatcher(isAnyOf(getAllInventoryLocationsAsync.fulfilled), (state, action) => {
      state.inventoryLocations = action.payload?.data ?? []
    })
  },
  reducers: { 
    
  },
})

export const {} = inventorySlice.actions

export default inventorySlice.reducer
